import './Model.css'

export const columns = [
  {
    name: 'Run',
    selector: (row) => row.run,
    width: '80px',
    center: true
  },
  {
    name: (
      <span className="column-title">
        X<sub>1</sub>
        <br />
        Channel diameter (mm)
      </span>
    ),
    selector: (row) => row.x1,
    width: '130px',
    center: true
  },
  {
    name: (
      <span className="column-title">
        X<sub>2</sub>
        <br />
        Distance between baffles (mm)
      </span>
    ),
    selector: (row) => row.x2,
    width: '130px',
    center: true
  },
  {
    name: (
      <span className="column-title">
        X<sub>3</sub>
        <br />
        Baffles width (mm)
      </span>
    ),
    selector: (row) => row.x3,
    width: '130px',
    center: true
  },
  {
    name: (
      <span className="column-title">
        X<sub>4</sub>
        <br />
        Inlet pressure (psi)
      </span>
    ),
    selector: (row) => row.x4,
    width: '120px',
    center: true
  }
]

export const data = [
  {
    run: '1',
    x1: '0,5',
    x2: '2,5',
    x3: '1',
    x4: '10'
  },
  {
    run: '2',
    x1: '0,5',
    x2: '2,5',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '3',
    x1: '0,5',
    x2: '2,5',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '4',
    x1: '0,5',
    x2: '2,5',
    x3: '2',
    x4: '10'
  },
  {
    run: '5',
    x1: '0,5',
    x2: '2,5',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '6',
    x1: '0,5',
    x2: '2,5',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '7',
    x1: '0,5',
    x2: '2,5',
    x3: '3',
    x4: '10'
  },
  {
    run: '8',
    x1: '0,5',
    x2: '2,5',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '9',
    x1: '0,5',
    x2: '2,5',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '10',
    x1: '0,5',
    x2: '5',
    x3: '1',
    x4: '10'
  },
  {
    run: '11',
    x1: '0,5',
    x2: '5',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '12',
    x1: '0,5',
    x2: '5',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '13',
    x1: '0,5',
    x2: '5',
    x3: '2',
    x4: '10'
  },
  {
    run: '14',
    x1: '0,5',
    x2: '5',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '15',
    x1: '0,5',
    x2: '5',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '16',
    x1: '0,5',
    x2: '5',
    x3: '3',
    x4: '10'
  },
  {
    run: '17',
    x1: '0,5',
    x2: '5',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '18',
    x1: '0,5',
    x2: '5',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '19',
    x1: '0,5',
    x2: '10',
    x3: '1',
    x4: '10'
  },
  {
    run: '20',
    x1: '0,5',
    x2: '10',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '21',
    x1: '0,5',
    x2: '10',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '22',
    x1: '0,5',
    x2: '10',
    x3: '2',
    x4: '10'
  },
  {
    run: '23',
    x1: '0,5',
    x2: '10',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '24',
    x1: '0,5',
    x2: '10',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '25',
    x1: '0,5',
    x2: '10',
    x3: '3',
    x4: '10'
  },
  {
    run: '26',
    x1: '0,5',
    x2: '10',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '27',
    x1: '0,5',
    x2: '10',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '28',
    x1: '1',
    x2: '2,5',
    x3: '1',
    x4: '10'
  },
  {
    run: '29',
    x1: '1',
    x2: '2,5',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '30',
    x1: '1',
    x2: '2,5',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '31',
    x1: '1',
    x2: '2,5',
    x3: '2',
    x4: '10'
  },
  {
    run: '32',
    x1: '1',
    x2: '2,5',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '33',
    x1: '1',
    x2: '2,5',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '34',
    x1: '1',
    x2: '2,5',
    x3: '3',
    x4: '10'
  },
  {
    run: '35',
    x1: '1',
    x2: '2,5',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '36',
    x1: '1',
    x2: '2,5',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '37',
    x1: '1',
    x2: '5',
    x3: '1',
    x4: '10'
  },
  {
    run: '38',
    x1: '1',
    x2: '5',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '39',
    x1: '1',
    x2: '5',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '40',
    x1: '1',
    x2: '5',
    x3: '2',
    x4: '10'
  },
  {
    run: '41',
    x1: '1',
    x2: '5',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '42',
    x1: '1',
    x2: '5',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '43',
    x1: '1',
    x2: '5',
    x3: '3',
    x4: '10'
  },
  {
    run: '44',
    x1: '1',
    x2: '5',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '45',
    x1: '1',
    x2: '5',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '46',
    x1: '1',
    x2: '10',
    x3: '1',
    x4: '10'
  },
  {
    run: '47',
    x1: '1',
    x2: '10',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '48',
    x1: '1',
    x2: '10',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '49',
    x1: '1',
    x2: '10',
    x3: '2',
    x4: '10'
  },
  {
    run: '50',
    x1: '1',
    x2: '10',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '51',
    x1: '1',
    x2: '10',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '52',
    x1: '1',
    x2: '10',
    x3: '3',
    x4: '10'
  },
  {
    run: '53',
    x1: '1',
    x2: '10',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '54',
    x1: '1',
    x2: '10',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '55',
    x1: '2',
    x2: '2,5',
    x3: '1',
    x4: '10'
  },
  {
    run: '56',
    x1: '2',
    x2: '2,5',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '57',
    x1: '2',
    x2: '2,5',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '58',
    x1: '2',
    x2: '2,5',
    x3: '2',
    x4: '10'
  },
  {
    run: '59',
    x1: '2',
    x2: '2,5',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '60',
    x1: '2',
    x2: '2,5',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '61',
    x1: '2',
    x2: '2,5',
    x3: '3',
    x4: '10'
  },
  {
    run: '62',
    x1: '2',
    x2: '2,5',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '63',
    x1: '2',
    x2: '2,5',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '64',
    x1: '2',
    x2: '5',
    x3: '1',
    x4: '10'
  },
  {
    run: '65',
    x1: '2',
    x2: '5',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '66',
    x1: '2',
    x2: '5',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '67',
    x1: '2',
    x2: '5',
    x3: '2',
    x4: '10'
  },
  {
    run: '68',
    x1: '2',
    x2: '5',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '69',
    x1: '2',
    x2: '5',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '70',
    x1: '2',
    x2: '5',
    x3: '3',
    x4: '10'
  },
  {
    run: '71',
    x1: '2',
    x2: '5',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '72',
    x1: '2',
    x2: '5',
    x3: '3',
    x4: '10 000'
  },
  {
    run: '73',
    x1: '2',
    x2: '10',
    x3: '1',
    x4: '10'
  },
  {
    run: '74',
    x1: '2',
    x2: '10',
    x3: '1',
    x4: '1 000'
  },
  {
    run: '75',
    x1: '2',
    x2: '10',
    x3: '1',
    x4: '10 000'
  },
  {
    run: '76',
    x1: '2',
    x2: '10',
    x3: '2',
    x4: '10'
  },
  {
    run: '77',
    x1: '2',
    x2: '10',
    x3: '2',
    x4: '1 000'
  },
  {
    run: '78',
    x1: '2',
    x2: '10',
    x3: '2',
    x4: '10 000'
  },
  {
    run: '79',
    x1: '2',
    x2: '10',
    x3: '3',
    x4: '10'
  },
  {
    run: '80',
    x1: '2',
    x2: '10',
    x3: '3',
    x4: '1 000'
  },
  {
    run: '81',
    x1: '2',
    x2: '10',
    x3: '3',
    x4: '10 000'
  }
]

export const customRowStyles = [
  {
    when: (row) =>
      ['3', '16', '23', '35', '42', '46', '58', '65', '81'].includes(row.run),
    style: {
      fontWeight: 'bold'
    }
  }
]
